import { projectDataType } from ".";

const opalOnyxData: projectDataType = {
  path: "opalonyx",
  title: "Opal Onyx",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965268/Art-Site/OpalOnyx/a002_c042_12207v0000762-02-v6-sm_eqmq1i.jpg",
  description:
    "Long standing collaboration with the band Opal Onyx, producing two album covers and a music video.",
  year: 2015,
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965271/Art-Site/OpalOnyx/screen_shot_2017-02-13_at_103117_am_ebrfhu.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965270/Art-Site/OpalOnyx/screen_shot_2017-02-13_at_102459_am_xiifyv.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965267/Art-Site/OpalOnyx/screen_shot_2017-02-13_at_102526_am_rq1gtq.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965267/Art-Site/OpalOnyx/screen_shot_2017-02-13_at_103220_am_os0aiy.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965270/Art-Site/OpalOnyx/opalonyxtrailerstill_mlltlo.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965269/Art-Site/OpalOnyx/screen_shot_2017-02-13_at_102602_am_qv947f.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965268/Art-Site/OpalOnyx/a002_c042_12207v0000762-02-v6-sm_eqmq1i.jpg",
    "Art-Site/OpalOnyx/opal-onyx-gif-semidesat-03_2_kolhjc.gif",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965270/Art-Site/OpalOnyx/a002_c043_1220fk0000622-03-02_copy_fug1kq.jpg",
  ],
  installPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965271/Art-Site/OpalOnyx/11221507_10207848608552640_8110332503757928963_o-u10129-fr_osqcgn.png",
  ],
  videos: [
    "https://vimeo.com/gisellezatonyl/opalonyxblackandcrimson?share=copy",
  ],
};

export default opalOnyxData;
